module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/news2.386b307b.svg";